var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.9907 0C54.3065 0 69.9869 15.6602 70 34.9739C70.013 54.3155 54.3233 70.0149 34.9739 70C15.6636 69.9851 -0.00373187 54.3006 6.66783e-07 34.9907C0.0037332 15.6808 15.6767 0.00559761 34.9907 0ZM43.575 17.6812C45.0004 18.1475 44.3923 19.462 42.9212 19.1706C37.5378 18.1045 32.1554 18.1252 26.774 19.2329C25.3521 19.5256 24.7599 18.2404 26.1356 17.7768C26.2005 17.755 26.2654 17.7332 26.3303 17.7116C27.0733 17.4644 27.3 16.4982 26.5197 16.5633C22.2646 16.9197 18.3958 18.3639 14.8816 20.7559C14.4291 21.0713 14.0549 21.4862 13.788 21.9688C12.1839 24.9706 10.8673 28.1174 9.85576 31.3671C8.29183 36.2818 7.34377 41.3048 7.29151 46.4807C7.28156 46.7693 7.37264 47.0524 7.54906 47.2812C11.3245 51.3021 16.0536 53.196 21.4975 53.459C21.714 53.459 22.0276 53.459 22.1414 53.3378C23.6175 51.6483 22.9634 49.0921 20.9634 48.0756C20.836 48.0108 20.7092 47.9451 20.5831 47.8782C19.1337 47.1078 19.7185 46.351 21.2256 47.0014C29.5027 50.5737 37.8008 50.9223 46.1197 48.0472C47.5538 47.5516 48.2711 48.5617 46.8606 49.1208C45.9623 49.4769 45.5792 50.6218 46.1967 51.3652C46.6393 51.898 47.0692 52.4234 47.4853 52.959C47.8119 53.3807 48.1646 53.4945 48.676 53.4646C53.9837 53.1418 58.6176 51.3096 62.3222 47.3987C62.5519 47.1603 62.6849 46.8451 62.6954 46.5143C62.5498 44.3293 62.4603 42.1314 62.1449 39.9688C61.1885 33.5475 59.1182 27.3423 56.0272 21.6329C55.8855 21.3694 55.685 21.1421 55.4412 20.9686C51.8244 18.4647 47.8511 16.929 43.4449 16.554C43.419 16.5518 43.3935 16.55 43.3682 16.5485C42.574 16.5018 42.8189 17.4338 43.575 17.6812Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3606 37.7727C48.3009 40.5267 46.1211 42.6706 43.4318 42.609C42.1476 42.5728 40.9293 42.0322 40.0409 41.1043C39.1526 40.1763 38.6658 38.9357 38.6859 37.6514C38.6946 36.9979 38.8327 36.3526 39.0923 35.7527C39.3518 35.1529 39.7276 34.6104 40.198 34.1565C40.6685 33.7027 41.2241 33.3465 41.833 33.1086C42.4418 32.8707 43.0918 32.7557 43.7454 32.7703C46.2947 32.802 48.4185 35.1101 48.3606 37.7727Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1976 37.7727C31.1378 40.5267 28.958 42.6706 26.2687 42.609C24.9845 42.5728 23.7662 42.0322 22.8778 41.1043C21.9895 40.1763 21.5027 38.9357 21.5228 37.6514C21.5315 36.9979 21.6696 36.3526 21.9292 35.7527C22.1887 35.1529 22.5645 34.6104 23.035 34.1565C23.5054 33.7027 24.0611 33.3465 24.6699 33.1086C25.2788 32.8707 25.9287 32.7557 26.5823 32.7703C29.1316 32.802 31.2554 35.1101 31.1976 37.7727Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -12.88,
    y1: 35,
    x2: 67.5561,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 36.9048,
    y1: 37.6897,
    x2: 48.024,
    y2: 37.6897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 19.7417,
    y1: 37.6897,
    x2: 30.8609,
    y2: 37.6897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000000"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.6d3a3ac2.svg";
export { ForwardRef as ReactComponent };